export const ACCOUNT = ':name/account';
export const BILLING = ':name/billing(?*query)';
export const BILLING_CARD = ':name/billing/card';
export const BILLING_CARD_PRODUCT = ':name/billing/card/:product';
export const BLANK = 'blank';
export const BOARD = 'b/:shortLink(/*path)';
export const BOARD_OLD = 'board/*path';
export const BOARD_REFERRAL = 'b/:shortLink/:name/:referrerUsername/recommend';
export const CARD = 'c/:id(/*path)';
export const CARD_OLD = 'card/(:slug/):idBoard/:cardComponent';
export const CARD_AND_BOARD_OLD = 'card/board/(:slug/):idBoard/:cardComponent';
export const CREATE_FIRST_BOARD = 'create-first-board(?*querystring)';
export const CREATE_FIRST_TEAM = 'create-first-team';
export const DOUBLE_SLASH = '/*search';
export const ENTERPRISE_ADMIN = 'e/:name/admin';
export const ENTERPRISE_ADMIN_TAB = 'e/:name/admin/*tab';
export const ERROR_PAGE = '*splat';
export const GO = 'go/*search';
export const INVITE_ACCEPT_BOARD = 'invite/accept-board';
export const INVITE_ACCEPT_TEAM = 'invite/accept-team';
export const MEMBER_ACTIVITY = ':username/activity';
export const MEMBER_ALL_BOARDS = ':username/boards';
export const MEMBER_CARDS = ':username/cards';
export const MEMBER_CARDS_FOR_ORG = ':username/cards/:orgname';
export const MEMBER_HOME = '';
export const MEMBER_HOME_BOARDS = ':orgname/home';
export const MEMBER_NOTIFICATIONS = ':username/notifications';
export const MEMBER_TASKS = ':username/tasks';
export const ORGANIZATION_BY_ID = 'org/:id';
export const ORGANIZATION_EXPORT = ':name/export';
export const ORGANIZATION_FREE_TRIAL = ':name/free-trial';
export const ORGANIZATION_GUESTS = ':name/members/guests';
export const ORGANIZATION_MEMBER_CARDS = ':name/:username/cards';
export const ORGANIZATION_MEMBERS = ':name/members';
export const ORGANIZATION_POWERUPS = ':name/power-ups';
export const ORGANIZATION_TABLES = ':name/tables';
export const POWER_UP_ADMIN = 'power-ups/admin(/:section)(/)';
export const POWER_UP_EDIT = 'power-ups/:idPlugin/edit(/:subsection)(/)';
export const POWER_UP_PUBLIC_DIRECTORY =
  'power-ups(/:section)(/:subsection)(/)';
export const PROFILE = ':name/profile';
export const SEARCH = 'search(?*query)';
export const SELECT_ORG_TO_UPGRADE = 'select-org-to-upgrade';
export const SELECT_TEAM_TO_UPGRADE = 'select-team-to-upgrade';
export const SHORTCUTS = 'shortcuts';
export const SHORTCUTS_OVERLAY = 'shortcuts/overlay';
export const TEAM_HIGHLIGHTS = ':orgname/highlights';
export const TEAM_REPORTS = ':orgname/reports';
export const TEMPLATES_SUBMIT = 'templates/submit';
export const TEMPLATES = 'templates(/:category)(/:templateSlug)(/)';
export const TEMPLATES_RECOMMEND =
  'templates(/:category)(/:templateSlug)(/:referrerUsername)/recommend(/)';
export const TO = 'to/*search';
export const USER_OR_ORG = ':name(/)';
export const WELCOME = 'welcome';

/**
 * This represents the order in which the paths are matched by the router
 */
export const ORDERED_ROUTE_LIST = [
  /**
   * Quick Boards (quick-boards.coffee)
   */
  GO,
  TO,
  DOUBLE_SLASH,
  /**
   * Power Ups (power-up-routes.tsx)
   */
  POWER_UP_ADMIN,
  POWER_UP_EDIT,
  POWER_UP_PUBLIC_DIRECTORY,
  /**
   * Other (other-routes.coffee)
   */
  CREATE_FIRST_TEAM,
  SHORTCUTS,
  SHORTCUTS_OVERLAY,
  BLANK,
  SELECT_ORG_TO_UPGRADE,
  SELECT_TEAM_TO_UPGRADE,
  SEARCH,
  TEMPLATES,
  TEMPLATES_RECOMMEND,
  /**
   * Invitation (power-up-routes.tsx)
   */
  INVITE_ACCEPT_BOARD,
  INVITE_ACCEPT_TEAM,
  /**
   * Board (board-routes.coffee)
   */
  BOARD_OLD,
  BOARD_REFERRAL,
  BOARD,
  CARD_AND_BOARD_OLD,
  CARD_OLD,
  CARD,
  WELCOME,
  CREATE_FIRST_BOARD,
  /**
   * User or Org (user-or-org-routes.coffee)
   */
  ACCOUNT,
  PROFILE,
  BILLING,
  BILLING_CARD,
  BILLING_CARD_PRODUCT,
  USER_OR_ORG,
  /**
   * Enterprise(enterprise-routes.coffee)
   */
  ENTERPRISE_ADMIN,
  ENTERPRISE_ADMIN_TAB,
  /**
   * Member (member-routes.coffee)
   */
  MEMBER_HOME,
  MEMBER_HOME_BOARDS,
  TEAM_HIGHLIGHTS,
  TEAM_REPORTS,
  MEMBER_ALL_BOARDS,
  MEMBER_CARDS,
  MEMBER_CARDS_FOR_ORG,
  MEMBER_NOTIFICATIONS,
  MEMBER_ACTIVITY,
  MEMBER_TASKS,
  /**
   * Organization (organization-routes.coffee)
   */
  ORGANIZATION_BY_ID,
  ORGANIZATION_GUESTS,
  ORGANIZATION_MEMBERS,
  ORGANIZATION_MEMBER_CARDS,
  ORGANIZATION_EXPORT,
  ORGANIZATION_POWERUPS,
  ORGANIZATION_TABLES,
  ORGANIZATION_FREE_TRIAL,
  /**
   * Catch all (catchall-route.coffee)
   */
  ERROR_PAGE,
];
